import { render, staticRenderFns } from "./abs-box.vue?vue&type=template&id=6f135ce4&"
import script from "./abs-box.vue?vue&type=script&lang=ts&"
export * from "./abs-box.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports